// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1uXdE","vLegacy":"SelectSecondary_vLegacy__NVtcy","error":"SelectSecondary_error__10Cfc","disabled":"SelectSecondary_disabled__3I69N"};